import { defineMessages } from 'react-intl';

const messages = defineMessages({
  processing: {
    id: 'processingMFA.processing',
    defaultMessage: 'This should only take a moment...',
  },
  mfaError: {
    id: 'processingMFA.mfaError',
    defaultMessage: 'There was an error during the login process, please try again.',
  },
  returnToLogin: {
    id: 'processingMFA.returnToLogin',
    defaultMessage: 'Return to login',
  },
});

export default messages;
